<template>
  <div id="app">
    <nav class="navbar is-fixed-top has-shadow">
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item">
          <img src="./assets/img/lineapps-transparente.png" alt="LineApps Logo" class="logo" />
        </router-link>
        <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarMenu" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarMenu" class="navbar-menu" :class="{ 'is-active': showNav }">
        <div class="navbar-start">
          <div class="navbar-item" v-if="estaAutenticado">
            <div class="control">
              <div class="select is-rounded">
                <select v-model="produtoUsuario" @change="selectModulo">
                  <option value="0" disabled>Acessar...</option>
                  <option :class="classOptionModule(papp.produto_app.sigla)" v-for="papp in produtoAppUsuario" :key="papp.produto_app.id" :value="papp.produto_app.sigla" :disabled="!papp.e_ativo">
                    {{ papp.produto_app.descricao }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <template v-if="estaAutenticado && (modulo == '2' || modulo == '3')">
            <a class="navbar-item" v-if="modulo == '2'">Simulação</a>
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">Administração</a>
              <div class="navbar-dropdown">
                <a class="navbar-item" v-if="modulo == '2'">Modelos</a>
                <hr class="navbar-divider" v-if="modulo == '2'">
                <a class="navbar-item" v-if="modulo == '2'">Tipos de Demonstrações de Resultados</a>
                <a class="navbar-item" v-if="modulo == '2'">Unidades de Medidas</a>
                <hr class="navbar-divider" v-if="modulo == '2'">
                <router-link to="/planoDeContas" class="navbar-item">Versões</router-link>
                <hr class="navbar-divider">
                <router-link to="/bpVersao" class="navbar-item">Balanços Patrimoniais</router-link>
                <router-link to="/dreVersao" class="navbar-item">DRE's</router-link>
                <hr class="navbar-divider">
                <router-link to="/outrasInformacoesVersao" class="navbar-item">Outras Informações</router-link>
                <hr class="navbar-divider">
                <router-link to="/indicador" class="navbar-item">Indicadores Gerenciais</router-link>
                <router-link to="/grafico" class="navbar-item">Gráficos</router-link>
                <router-link to="/ValorReferenciaIndicador" class="navbar-item">Valores de Referência</router-link>
                <hr class="navbar-divider">
                <router-link to="/perfil" class="navbar-item">Perfil</router-link>
                <router-link to="/notaExplicativa" class="navbar-item">Notas Explicativas</router-link>
              </div>
            </div>
            
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">Análises</a>
              <div class="navbar-dropdown">
                <router-link to="/PeriodoPerfil" class="navbar-item">Períodos</router-link>
                <hr class="navbar-divider" v-if="modulo == '3'">
                <router-link to="/Balancete" class="navbar-item">Balancete</router-link>
                <router-link to="/bpPeriodo" class="navbar-item">Balanço Patrimonial</router-link>
                <router-link to="/drePeriodo" class="navbar-item">DRE</router-link>
                <hr class="navbar-divider">
                <router-link to="/outrasInformacoesPeriodo" class="navbar-item">Outras Informações</router-link>
                <hr class="navbar-divider">
                <router-link to="/IndicadorPeriodo" class="navbar-item">Dashboard</router-link>
              </div>
            </div>
          </template>

          <template v-if="estaAutenticado && modulo == '1'">
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">Gestão da Carteira</a>
              <div class="navbar-dropdown">
                <router-link to="/dashboard" class="navbar-item">Dashboard</router-link>
                <router-link to="/periodo" class="navbar-item">Períodos</router-link>
                <router-link to="/aportes" class="navbar-item">Aportes</router-link>
                <hr class="navbar-divider">
                <router-link to="/mapaProventos" class="navbar-item">Mapa da Geração de Renda</router-link>
                <hr class="navbar-divider">
                <router-link to="/modelagemCarteira" class="navbar-item">Modelagem de Carteiras</router-link>
              </div>
            </div>
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">Corretoras</a>
              <div class="navbar-dropdown">
                <router-link to="/corretoraExtrato" class="navbar-item">Extratos</router-link>
                <router-link to="/notaNegociacao" class="navbar-item">Notas de Negociação</router-link>
                <router-link to="/corretoraSelecao" class="navbar-item">Seleção</router-link>
              </div>
            </div>
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">Mais</a>
              <div class="navbar-dropdown">
                <router-link to="/benchmark" class="navbar-item">Benchmarks</router-link>
                <router-link to="/empresa" class="navbar-item">Empresas</router-link>
                <router-link to="/ativo" class="navbar-item">Ativos</router-link>
              </div>
            </div>
          </template>
        </div>

        <div class="navbar-end">
          <div class="navbar-item login-controls">
            <div class="field is-grouped is-align-items-center" v-if="!estaAutenticado">
              <p class="control has-icons-left">
                <input class="input is-rounded" type="text" placeholder="Usuário" v-model="usuario">
                <span class="icon is-left">
                  <i class="fas fa-user"></i>
                </span>
              </p>
              <p class="control has-icons-left">
                <input class="input is-rounded" type="password" placeholder="Senha" v-model="senha">
                <span class="icon is-left">
                  <i class="fas fa-lock"></i>
                </span>
              </p>
              <p class="control">
                <button class="button is-primary is-rounded" @click="login">Login</button>
              </p>
            </div>
            <div class="field is-grouped is-align-items-center" v-else>
              <p class="control">
                <span class="navbar-item has-text-white is-unselectable">{{ usuario || 'Usuário' }}</span>
              </p>
              <p class="control">
                <button class="button is-danger is-rounded" @click="logout" title="Sair">
                  <span class="icon">
                    <i class="fas fa-door-open"></i>
                  </span>
                </button>
              </p>
              <p class="control">
                <button class="button is-warning is-rounded" @click="changePassword" title="Trocar Senha | Reset Token">
                  <span class="icon">
                    <i class="fas fa-key"></i>
                  </span>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" @click="isShowModal = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Trocar Senha | Gerar Token</p>
          <button class="delete" aria-label="close" @click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form>
            <div class="field is-horizontal">
              <div class="radios ">
                <label class="radio">
                    <input type="radio" value='0' v-model="optTela"/>
                    Trocar Senha
                </label>
                <label class="radio">
                    <input type="radio" value='1' v-model="optTela"/>
                    Token
                </label>
              </div>
            </div>
            <br>

            <!-- Trocar Senha -->
            <div class="field is-horizontal" v-if="optTela == '0'">
              <div class="field-label is-normal">
                <label class="label">Senha Atual</label>
              </div>
              <div class="field-body">
                <div class="field is-fullwidth">
                  <input class="input" type="password" placeholder="Informe sua senha atual" v-model="senhaAntiga">
                </div>
              </div>
            </div>
            <div class="field is-horizontal" v-if="optTela == '0'">
              <div class="field-label is-normal">
                <label class="label">Nova Senha</label>
              </div>
              <div class="field-body">
                <div class="field is-fullwidth">
                  <input class="input" type="password" placeholder="Informe a sua nova senha" v-model="novaSenha">
                </div>
              </div>
            </div>
            <div class="field is-horizontal" v-if="optTela == '0'">
              <div class="field-label is-normal">
                <label class="label">Confirme</label>
              </div>
              <div class="field-body">
                <div class="field is-fullwidth">
                  <input class="input" type="password" placeholder="Digite novamente a nova senha" v-model="novaSenhaConfirmar">
                </div>
              </div>
            </div>

            <!-- Token -->
            <div class="field is-horizontal" v-if="optTela == '1'">
              <div class="field-label is-normal">
                <label class="label">Token</label>
              </div>
              <div class="field-body">
                <div class="field is-fullwidth">
                  <input class="input" type="text" placeholder="" v-model="tokenUsuario" disabled>
                </div>
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="reset" v-if="optTela == '1'">Reset</button>
          <button class="button is-success" @click="save" v-if="optTela == '0'">Salvar</button>
          <button class="button" @click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <section class="section">
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
import { http } from './services/config'

export default {
  name: 'App',

  data() {
    return {
      usuario: null,
      senha: null,
      estaAutenticado: false,
      showNav: false,
      isShowModal: false,
      modulo: '0',
      novaSenha: null,
      novaSenhaConfirmar: null,
      senhaAntiga: null,
      produtoAppUsuario: [],
      produtoUsuario: '0',
      optTela: '0',
      tokenUsuario: ''
    }
  },

  methods: {

    async login() {

      try {

        // Garante CSRF
        await http.get('csrf/')

        const response = await http.post('rest_auth/login/', {
          username: this.usuario,
          password: this.senha
        })

        if (response.status === 200) {

          this.estaAutenticado = true

          // Obtém usuário autenticado
          const userResponse = await http.get('rest_auth/user/')

          this.$store.state.idUser = userResponse.data.pk
          this.usuario = userResponse.data.username

          // Produtos do usuário
          const produtosResponse = await http.get('produtoAppUsuario/listarProdutosApp')

          this.produtoAppUsuario = produtosResponse.data.results || []

          localStorage.setItem(
            'produtoAppUsuario',
            JSON.stringify(this.produtoAppUsuario)
          )

          if (this.produtoAppUsuario.length === 1) {

            this.produtoUsuario =
              this.produtoAppUsuario[0].produto_app.sigla

            this.selectModulo()

          } else {

            this.modulo = '0'

          }

          this.$store.state.selectedModule = this.modulo

          // Token legado da sua API específica
          http.get('usuarios/obterToken').then(response => {
            this.tokenUsuario = response.data.token
          })

        }

      } catch (e) {

        alert('Credenciais inválidas!')
        console.error('Erro ao fazer login:', e)

      }

    },

    async logout() {

      try {

        await http.post('rest_auth/logout/')

        this.clearStorage()

        if (
          ![
            'http://localhost:8080/#/',
            'https://pgpaf.com.br/#/',
            'https://pgpaf.com.br:8443/#/'
          ].includes(window.location.href)
        ) {
          this.$router.push('/')
        }

      } catch (e) {
        console.error('Erro ao fazer logout:', e)
      }

    },

    changePassword() {
      this.senhaAntiga = null
      this.novaSenha = null
      this.novaSenhaConfirmar = null
      this.isShowModal = true

    },

    selectModulo() {

      if (this.produtoUsuario === 'QUIVER') {
        this.modulo = '1'
      } else if (this.produtoUsuario === 'PROMODEL') {
        this.modulo = '2'
      } else {
        this.modulo = '3'
      }

      localStorage.setItem('modulo', this.modulo)
      localStorage.setItem('produtoUsuario', this.produtoUsuario)

      this.$store.state.selectedModule = this.modulo

      if (
        ![
          'http://localhost:8080/#/',
          'https://pgpaf.com.br/#/',
          'https://pgpaf.com.br:8443/#/'
        ].includes(window.location.href)
      ) {
        this.$router.push('/')
      }

    },

    classOptionModule(opcao) {
      if (opcao === 'BOARD') {
        return 'has-text-danger'
      } else if (opcao === 'QUIVER') {
        return 'has-text-warning'
      } else {
        return 'has-text-success'
      }
    },

    async save() {

      try {

        if (!this.senhaAntiga) {
          alert('Senha atual não informada!')
          return
        }

        if (!this.novaSenha) {
          alert('Nova senha não informada!')
          return
        }

        if (!this.novaSenhaConfirmar) {
          alert('Confirmação da nova senha não informada!')
          return
        }

        if (this.novaSenha !== this.novaSenhaConfirmar) {
          alert('A senha de confirmação está diferente da nova senha informada!')
          return
        }

        const response = await http.post(
          'rest_auth/password/change/',
          {
            new_password1: this.novaSenha,
            new_password2: this.novaSenhaConfirmar,
            old_password: this.senhaAntiga
          }
        )

        if (response.status === 200) {

          alert('Senha modificada com sucesso!')

          this.isShowModal = false

          this.logout()

        }

      } catch (e) {

        const errors = e.response?.data || {}

        if (errors.new_password2) {
          alert(errors.new_password2[0])
        } else if (errors.new_password1) {
          alert(errors.new_password1[0])
        } else if (errors.old_password) {
          alert(errors.old_password[0])
        } else {
          alert('Erro ao alterar senha!')
        }

        console.error('Erro ao alterar senha:', e)

      }

    },

    async reset() {
      await http.post('usuarios/resetToken').then(response => {
        this.tokenUsuario = response.data.token
        this.isShowModal = false
        this.clearStorage()

      })

    },

    async clearStorage() {
      this.usuario = null
      this.senha = null
      this.estaAutenticado = false

      this.$store.state.idUser = null

      this.produtoUsuario = '0'
      this.produtoAppUsuario = []

      this.$store.state.selectedModule = this.modulo

      localStorage.removeItem('modulo')
      localStorage.removeItem('produtoUsuario')
      localStorage.removeItem('produtoAppUsuario')

      if (this.modulo != '0') {
        alert(
          this.modulo === '1'
            ? 'Até breve e bons investimentos!'
            : 'Até breve!'
        )
      }

      this.modulo = '0'

      if (
        ![
          'http://localhost:8080/#/',
          'https://pgpaf.com.br/#/',
          'https://pgpaf.com.br:8443/#/'
        ].includes(window.location.href)
      ) {
        this.$router.push('/')
      }

    }

  },

  async mounted() {
    try {
      // Garante CSRF
      await http.get('csrf/')

      // Verifica sessão automaticamente
      const response = await http.get('rest_auth/user/')

      this.estaAutenticado = true
      this.$store.state.idUser = response.data.pk
      this.usuario = response.data.username

      const produtoUsuario = localStorage.getItem('produtoUsuario')
      const modulo = localStorage.getItem('modulo')

      const produtos = JSON.parse(
        localStorage.getItem('produtoAppUsuario') || '[]'
      )

      this.produtoUsuario = produtoUsuario || '0'
      this.modulo = modulo || '0'
      this.produtoAppUsuario = produtos

      this.$store.state.selectedModule = this.modulo

    } catch (e) {
      console.error('Usuário não autenticado:', e)
      this.clearStorage()
    }

  }

}
</script>

<style scoped>
  .navbar {
    transition: background-color 0.3s ease; /* Especificar apenas background-color */
  }
  .navbar.is-fixed-top {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .navbar-brand .logo {
    max-height: 2.5rem;
    margin-right: 1rem;
  }
  .navbar-item, .navbar-link {
    font-weight: 500;
    transition: background-color 0.2s ease;
    border: 1px solid transparent; /* Reserva espaço para evitar tremida */
  }
  .navbar-item:hover, .navbar-link:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid transparent; /* Mantém o espaço reservado */
  }
  .navbar-dropdown {
    border-radius: 0.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid transparent; /* Evita deslocamento */
  }
  .navbar-divider {
    margin: 0.25rem 0;
  }
  .select select {
    border-radius: 1rem;
    padding: 0.5rem 1rem;
    border: 1px solid transparent; /* Evita tremida */
  }
  .login-controls {
    display: flex;
    align-items: center;
  }
  .field.is-grouped.is-align-items-center {
    display: flex;
    align-items: center;
  }
  .field.is-grouped.is-align-items-center .control {
    margin-right: 0.5rem;
  }
  .field.is-grouped.is-align-items-center .control .input,
  .field.is-grouped.is-align-items-center .control .button {
    height: 2.5rem;
    line-height: 1.5;
    border: 1px solid transparent; /* Evita tremida */
    transition: background-color 0.2s ease, color 0.2s ease; /* Especificar transições */
  }
  .input.is-rounded {
    border-radius: 1rem;
  }
  .button.is-rounded {
    border-radius: 1rem;
  }
  .navbar-item.has-text-white.is-unselectable {
    padding: 0.5rem 0.75rem;
  }
  .modal-card {
    max-width: 500px;
    margin: 0 auto;
    border-radius: 0.5rem;
  }
  .modal-card-head, .modal-card-foot {
    border-radius: 0.5rem;
  }
  .section {
    padding-top: 4.5rem;
  }
  @media screen and (max-width: 1023px) {
    .navbar-menu.is-active {
      background-color: #3273dc;
      padding: 1rem;
    }
    .navbar-item, .navbar-link {
      color: white !important;
    }
    .login-controls {
      flex-direction: column;
      align-items: stretch;
    }
    .field.is-grouped.is-align-items-center {
      flex-direction: column;
      align-items: stretch;
    }
    .field.is-grouped.is-align-items-center .control {
      margin-right: 0;
      margin-bottom: 0.5rem;
    }
    .field.is-grouped.is-align-items-center .control .input,
    .field.is-grouped.is-align-items-center .control .button {
      width: 100%;
    }
  }
  @import './assets/css/lineapps.css';
</style>
